function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, Object) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['icon-container'] = function(attrs) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const {
          icon,
          iconSide,
          iconColor
        } = attrs;;
        __jade_nodes = __jade_nodes.concat(h("div", {
          "attrs": {
            icon
          },
          "class": Object.assign({}, {
            [`icon-side-${iconSide}`]: true
          }, {
            'icon-container': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("svg-icon", {
            "attrs": {
              icon,
              color: iconColor
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          'toggle-blue': $attr(`color`) === `blue` || $attr(`blue`),
          'toggle-grey': $attr(`color`) === `grey`,
          'toggle-large': $attr(`size`) === `large` || $attr(`large`),
          'toggle-small': $attr(`size`) === `small` || $attr(`small`),
          'toggle-square': $attr(`square`) || $attr(`theme`) === `square`,
          'theme-lite': $attr(`theme`) === `lite`,
        }, {
          'mp-toggle': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((function() {
          var $$obj = ($helpers.toggleOptions());
          var $$eachNodes;
          var $$iterated = false;
          if (Array.isArray($$obj)) {
            $$eachNodes = $$obj.reduce(function($$eachNodes, toggleOption, idx) {
              $$iterated = true;
              return $$eachNodes.concat((function() {
                var __jade_nodes = [];
                const ToggleIconSide = $helpers.ToggleIconSide;;
                const {
                  icon,
                  iconSide = ToggleIconSide.Right,
                  iconColor,
                  label,
                  value,
                  disabled,
                  error,
                  tooltipLabel
                } = toggleOption;;
                const hasTextAndIcon = icon && label.length;;
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "on": {
                    click: () => disabled ? null : $helpers.selectOption(value),
                  },
                  "style": $helpers.getStyleOverride(idx),
                  "class": Object.assign({}, {
                    'mp-toggle-selected': value === $attr(`selected`),
                    'mp-toggle-disabled': disabled,
                    'mp-toggle-error': error,
                    'mp-toggle-text-and-icon': hasTextAndIcon,
                  }, {
                    'mp-toggle-option': true
                  }),
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat((icon && iconSide == ToggleIconSide.Left) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(jade_mixins['icon-container'].call(this, {
                      icon,
                      iconSide,
                      iconColor
                    }));;
                    return __jade_nodes
                  }).call(this)) : undefined);
                  __jade_nodes = __jade_nodes.concat(label);
                  __jade_nodes = __jade_nodes.concat((icon && iconSide == ToggleIconSide.Right) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(jade_mixins['icon-container'].call(this, {
                      icon,
                      iconSide,
                      iconColor
                    }));;
                    return __jade_nodes
                  }).call(this)) : undefined);
                  __jade_nodes = __jade_nodes.concat((tooltipLabel) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                      "attrs": {
                        placement: `top`
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(tooltipLabel);;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)) : undefined);;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this));
            }, []);
          } else {
            $$eachNodes = [];
            for (var $$objKey in $$obj) {
              (function() {
                var idx = $$objKey;
                if ($$obj.hasOwnProperty(idx)) {
                  $$iterated = true;
                  var toggleOption = $$obj[idx];
                  $$eachNodes = $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    const ToggleIconSide = $helpers.ToggleIconSide;;
                    const {
                      icon,
                      iconSide = ToggleIconSide.Right,
                      iconColor,
                      label,
                      value,
                      disabled,
                      error,
                      tooltipLabel
                    } = toggleOption;;
                    const hasTextAndIcon = icon && label.length;;
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "on": {
                        click: () => disabled ? null : $helpers.selectOption(value),
                      },
                      "style": $helpers.getStyleOverride(idx),
                      "class": Object.assign({}, {
                        'mp-toggle-selected': value === $attr(`selected`),
                        'mp-toggle-disabled': disabled,
                        'mp-toggle-error': error,
                        'mp-toggle-text-and-icon': hasTextAndIcon,
                      }, {
                        'mp-toggle-option': true
                      }),
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((icon && iconSide == ToggleIconSide.Left) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(jade_mixins['icon-container'].call(this, {
                          icon,
                          iconSide,
                          iconColor
                        }));;
                        return __jade_nodes
                      }).call(this)) : undefined);
                      __jade_nodes = __jade_nodes.concat(label);
                      __jade_nodes = __jade_nodes.concat((icon && iconSide == ToggleIconSide.Right) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(jade_mixins['icon-container'].call(this, {
                          icon,
                          iconSide,
                          iconColor
                        }));;
                        return __jade_nodes
                      }).call(this)) : undefined);
                      __jade_nodes = __jade_nodes.concat((tooltipLabel) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                          "attrs": {
                            placement: `top`
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(tooltipLabel);;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)) : undefined);;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this));
                }
              })();
            }
          }

          return $$eachNodes;
        })());;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;